import {
  GET_PUBLICACOES,
  GET_PUBLICACOES_PENDENTES,
  UPDATE_PUBLICACAO,
  GET_PUBLICACOES_FAIL,
  GET_PUBLICACOES_SUCCESS,
  UPDATE_PUBLICACAO_SUCCESS,
  UPDATE_PUBLICACAO_FAIL,
  GET_PUBLICACAO,
  GET_PUBLICACAO_FAIL,
  GET_PUBLICACAO_SUCCESS,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  FIRST_PAGE,
  LAST_PAGE
} from "./actionTypes";

export const getPublicacoes = () => ({
  type: GET_PUBLICACOES,
})

export const getPublicacoesPendentes = filtros => ({
  type: GET_PUBLICACOES_PENDENTES,
  payload: filtros,
})

export const getPublicacao = cnj => ({
  type: GET_PUBLICACAO,
  payload: cnj,
});

export const getPublicacaoSuccess = publicacao => ({
  type: GET_PUBLICACAO_SUCCESS,
  payload: publicacao,
});

export const getPublicacaoFail = error => ({
  type: GET_PUBLICACAO_FAIL,
  payload: error,
});

export const getPublicacoesSuccess = publicacoes => ({
  type: GET_PUBLICACOES_SUCCESS,
  payload: publicacoes,
})

export const getPublicacoesFail = error => ({
  type: GET_PUBLICACOES_FAIL,
  payload: error,
})

export const updatePublicacao = publicacao => ({
  type: UPDATE_PUBLICACAO,
  payload: publicacao,
})

export const updatePublicacaoSuccess = publicacao => ({
  type: UPDATE_PUBLICACAO_SUCCESS,
  payload: publicacao,
})

export const updatePublicacaoFail = error => ({
  type: UPDATE_PUBLICACAO_FAIL,
  payload: error,
})

export const setCNJValue = (value) => ({
  type: 'SET_CNJ_VALUE',
  payload: value,
});

export const nextPage = () => ({
  type: NEXT_PAGE,
});

export const previousPage = () => ({
  type: PREVIOUS_PAGE
});

export const firstPage = () => ({
  type: FIRST_PAGE,
});

export const lastPage = () => ({
  type: LAST_PAGE
});
